import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UILink from 'UIComponents/link/UILink';
import { LINK_CLICK } from '../../tracking/trackerActions';
import { getUsageTracker } from '../../utils/usage-tracker/index';
import { jsx as _jsx } from "react/jsx-runtime";
function LinkWithTracking(props) {
  const {
    href,
    linkText
  } = props;
  const onClick = () => {
    const tracker = getUsageTracker();
    const pathname = window.location.pathname.split('/');
    const page = pathname[pathname.length - 1];
    tracker.track(LINK_CLICK, {
      link: href,
      page
    });
  };

  // Use Router links if relative
  if (href.startsWith('/')) {
    return /*#__PURE__*/_jsx(UIRouterLink, {
      to: href,
      onClick: onClick,
      children: linkText
    });
  } else if (href.startsWith('#')) {
    return /*#__PURE__*/_jsx(UILink, {
      href: href,
      onClick: onClick,
      children: linkText
    });
  }
  return /*#__PURE__*/_jsx(UILink, {
    href: href,
    external: true,
    onClick: onClick,
    children: linkText
  });
}
export default LinkWithTracking;